import PageLoading from '@/components/PageLoading';
import { listCurrencySymbols } from '@/services/currency-display';
import {
  configureCurrencySymbols,
  configureFallbackCurrencySymbols,
} from '@/utils/money';
import { useEffect, useState, type PropsWithChildren } from 'react';

/**
 * 符号表先于语言包初始化，保证模块级金额单位词条读取同一份后端规则。
 *
 * 拉不到（网关免身份清单漏配、断网）时**不再拦整站**：按下与后端相同的规则兜底符号，
 * 照常渲染。否则登录页自己也要等这张表，会话过期的人看到的是一张「网络异常」错误页，
 * 连登录表单都回不去（体验条目 平台运营后台-000 / 总会后台-011/026）。
 */
export default function CurrencyBootstrap({ children }: PropsWithChildren) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let alive = true;
    listCurrencySymbols()
      .then((symbols) => {
        if (!alive) return;
        configureCurrencySymbols(symbols);
        setReady(true);
      })
      .catch((error: unknown) => {
        if (!alive) return;
        // 只留一条控制台线索：缺的是网关那条免身份路径，界面本身按兜底规则照常展示
        console.warn('币种符号表拉取失败，本次启动按 HKD/HK$ 与币种代码兜底', error);
        configureFallbackCurrencySymbols();
        setReady(true);
      });
    return () => {
      alive = false;
    };
  }, []);

  return ready ? children : <PageLoading />;
}
